module.exports = __webpack_public_path__ + "static/media/foto-bert.dcc1f52a.jpg";